module.exports = __webpack_public_path__ + "static/media/Spinner.30a47284.svg";